import { render } from "./PlansAdd.vue?vue&type=template&id=0a07ec76"
import script from "./PlansAdd.vue?vue&type=script&lang=js"
export * from "./PlansAdd.vue?vue&type=script&lang=js"

import "./PlansAdd.vue?vue&type=style&index=0&id=0a07ec76&lang=css"

import exportComponent from "E:\\PhpstormProjects\\zoodkomak_tv_panel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__